import {IClientScan} from '@/models/clientScans/IClientScan';
import {ClientScanKey} from '@/models/clientScans/ClientScanKey';
import {ScanType} from '@/models/clientScans/ScanType';
import {type Agreement, isAgreementChecked} from '@/modules/client/views/client-agreements/Agreements';
import AuthService from '@/modules/user/AuthService';
import {OrganisationId} from '@/models/enums/OrganisationId';

export const ClientScansDtoLendi: IClientScan[] = [
  {
    key: ClientScanKey.AGREEMENT,
    documentName: 'Formularz zgód na przetwarzanie danych osobowych przez Lendi sp. z o.o.',
    type: ScanType.RODO,
    condition: c => !c.isCompany,
    documentUrl: 'https://static.lendi.pl/platforma/Zgoda_papierowa_RODO_Lendi.pdf',
    required: (v: Agreement[]) => isAgreementChecked(v, `AcceptsLendiPersonalDataProcessing`),
  },
  {
    key: ClientScanKey.AGREEMENT,
    documentName: 'Formularz zgód na przetwarzanie danych osobowych przez Lendi sp. z o.o.',
    type: ScanType.RODO,
    condition: c => c.isCompany,
    documentUrl: 'https://static.lendi.pl/platforma/01_done_Zgoda_RODO_LENDI_SME.pdf',
    required: (v: Agreement[]) => isAgreementChecked(v, `AcceptsLendiPersonalDataProcessing`),
  },
  {
    key: ClientScanKey.OFI,
    documentName: 'Ogólny formularz informacyjny o Pośredniku Lendi sp. z o.o.',
    type: ScanType.OFI,
    documentUrl: 'https://platforma.lendi.pl/v2/app/knowledge/filemanager/%2FUODO%20i%20OFI%20-%20Lendi',
    required: (v: Agreement[]) => isAgreementChecked(v, `AcceptsLendiCommercialInformation`),
  },
  {
    key: ClientScanKey.AGREEMENT_FINAMAX,
    documentName: 'Formularz zgód na przetwarzanie danych osobowych przez FINAMAX sp. z o.o.',
    type: ScanType.RODO,
    documentUrl: 'https://static.lendi.pl/platforma/RODO_FINAMAX.pdf',
    condition: c => AuthService.User?.organisationId === OrganisationId.FINAMAX,
    required: (v: Agreement[]) => isAgreementChecked(v, 'AcceptsFinamaxPersonalDataProcessing'),
  },
  {
    key: ClientScanKey.OFI_FINAMAX,
    documentName: 'Ogólny formularz informacyjny o Pośredniku FINAMAX sp. z o.o.',
    type: ScanType.OFI,
    documentUrl: 'https://static.lendi.pl/platforma/Informacja_o_posredniku_kredytowym_Finamax_LENDI.pdf',
    condition: c => AuthService.User?.organisationId === OrganisationId.FINAMAX,
    required: (v: Agreement[]) => isAgreementChecked(v, 'AcceptsFinamaxCommercialInformation'),
  },
];
